import _sortBy from 'lodash/sortBy';
import { parse } from 'date-fns';
import { makeEntityScaffold } from '@classpass/saga-tools';

import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT } from 'constants/logic';
import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';

async function handler({ httpClient }, query) {
  const endpoint = URLS.reports.campaigns(query);
  const resp = await httpClient.get(endpoint);
  const { reservations = [] } = transformV2ClientResponse(resp);

  return reservations.map(({ scheduleStartDate, scheduleStartTime, ...rest }) => ({
    ...rest,
    scheduleStartDateTime: parse(
      `${scheduleStartDate} ${scheduleStartTime}`,
      `${SERVER_DATE_FORMAT} ${SERVER_TIME_FORMAT}`,
      new Date()
    ),
  }));
}

export default makeEntityScaffold('SAGA.API.REPORTS_CAMPAIGNS', handler, {
  defaultKey: (client, params) =>
    params
      ? _sortBy(Object.entries(params), ([key]) => key)
          .map(([key, value]) => [key, value].join('='))
          .join('&')
      : 'all',
});
